import { OutboundReceiptStatus } from '@typings/entities/OutboundReceipt'
import { t } from '@lingui/macro'
import { FlagAppearanceType } from '@constants/FlagAppearance'

export const outboundReceiptStatusTrans: Record<OutboundReceiptStatus, () => string> = {
  new: () => t({ id: `outboundReceiptStatus.new`, message: `new` }),
  processed: () => t({ id: `outboundReceiptStatus.processed`, message: `processed` }),
  failed: () => t({ id: `outboundReceiptStatus.failed`, message: `failed` }),
}

export const outboundReceiptStatusToColor: Record<OutboundReceiptStatus, FlagAppearanceType> = {
  new: 'blueSubtle',
  processed: 'orangeSubtle',
  failed: 'redBold',
}
